import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  FlexGrid,
  Header,
  Text,
  Container,
  Constraint,
} from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import styles from './SavingsTools.module.css';
import { localyticsEvent } from '../../../lib/utils';
import { ANALYTICS_EVENTS } from '../../constants';

const cx = classnames.bind(styles);

const TOOLS = [
  {
    name: 'Trip Cost Calculator',
    key: 'Trip_Cost_Calculator',
    description: 'Plan your next road trip with our handy tool that can help you save.',
    href: '//www.gasbuddy.com/tripcostcalculator',
  },
  {
    name: 'Outage Tracker',
    key: 'Outage_Tracker',
    description: 'Find out which stations have power and fuel during natural disasters.',
    href: '//tracker.gasbuddy.com',
  },
  {
    name: 'Gas Price Map',
    key: 'Gas_Price_Map',
    description: 'Explore real-time gas prices in specific areas or wide-angle trends.',
    href: '//www.gasbuddy.com/gaspricemap',
  },
  {
    name: 'Fuel Insights',
    key: 'Fuel_Insights',
    description: 'Explore price trends by various regions and time periods.',
    href: '//fuelinsights.gasbuddy.com',
  },
  {
    name: 'Fuel Logbook',
    key: 'Fuel_Logbook',
    description: 'Log your fuel purchases and track your fuel economy',
    href: '/account/fuel-log-book',
  },
  {
    name: 'Vehicle Recalls',
    key: 'Vehicle_Recalls',
    description: 'Find out if your vehicle has any recalls, and what to do about it!',
    href: '/vehicles/recalls/search',
  },
];

function createLinkClickHandler(key) {
  return function handleLinkClick() {
    if (key === 'Vehicle_Recalls') {
      localyticsEvent(ANALYTICS_EVENTS.OPEN_RECALL_SEARCH_PAGE, {
        Page: key,
        source: 'saving_tools_link',
      });
    } else {
      localyticsEvent(ANALYTICS_EVENTS.SAVINGS_LINK_CLICK, { Page: key });
    }
  };
}

const renderTool = tool => (
  <FlexGrid.Column key={tool.href} mobile={12} tablet={6}>
    <Button
      as="a"
      className={cx('tool')}
      size="lg"
      fluid
      href={tool.href}
      onClick={createLinkClickHandler(tool.key)}
      secondary
    >
      <span className={styles.toolLinkLabel}>{tool.name}</span>
      <p className={styles.toolLinkDescription}>{tool.description}</p>
    </Button>
  </FlexGrid.Column>
);

function SavingsTools({
  className,
  country,
  tools,
  ...rest
}) {
  return (
    <div className={cx('container', className)} {...rest}>
      <Container>
        <Header as="h2" className={cx('header')}>Savings tools</Header>
        <Text as="p" centered className={cx('text')}>
          Our gas tools can help you find a wide range of information on gas prices and how to save every time you drive.
        </Text>
        <br />
        <br />
        <Constraint centered tablet={10} desktop={8}>
          <FlexGrid className={cx('tools')} container>
            {tools.map(renderTool)}
          </FlexGrid>
        </Constraint>
      </Container>
    </div>
  );
}

SavingsTools.propTypes = {
  className: PropTypes.string,
  country: PropTypes.string,
  tools: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  })),
};

SavingsTools.defaultProps = {
  className: undefined,
  country: 'US',
  tools: TOOLS,
};

export default SavingsTools;
